import { render } from "./lida-table-column.vue?vue&type=template&id=6513de62&scoped=true"
import script from "./lida-table-column.vue?vue&type=script&lang=js"
export * from "./lida-table-column.vue?vue&type=script&lang=js"

import "./lida-table-column.vue?vue&type=style&index=0&id=6513de62&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6513de62"]])

export default __exports__